import { all } from 'redux-saga/effects';
import { authSaga } from 'ducks/auth';
import { orderSaga } from 'shared-react/ducks/order';

export default function* rootSaga() {
    yield all([
        authSaga(),
        orderSaga(),
    ]);
}